import React from 'react';
import styles from './pain-points.module.scss';
import { PainClock, PainExcel, PainNoshow } from 'shared/svg';
import { useAppMediaQuery } from 'shared/hooks';

export const PainPoints: React.FC = () => {
  const isMobile = useAppMediaQuery('mobileL');
  const iconSize = isMobile ? 28 : 32;

  const pains = [
    {
      icon: <PainClock width={iconSize} height={iconSize} />,
      title: 'Клиенты не приходят без предупреждения',
      description:
        'До 30% записей теряется. Администратор тратит часы на обзвон.',
      solution: 'Автоматические напоминания в VK — неявки снижаются до нуля',
    },
    {
      icon: <PainExcel width={iconSize} height={iconSize} />,
      title: 'Администратор перегружен звонками',
      description: 'Пока администратор на телефоне — другие клиенты ждут.',
      solution: 'Онлайн-запись 24/7 — клиенты бронируют сами без звонка',
    },
    {
      icon: <PainNoshow width={iconSize} height={iconSize} />,
      title: 'Нет записи ночью и в выходные',
      description:
        'После закрытия звонки остаются без ответа — клиенты уходят к конкурентам.',
      solution: 'Принимайте записи 24/7, даже когда салон закрыт',
    },
  ];

  return (
    <div className={styles.pain_points_outer}>
      <div className={styles.pain_points}>
        <div className={styles.pain_points__header}>
          <h2 className={styles.header__title}>
            Теряете до 30% выручки из-за хаоса в записях?
          </h2>
        </div>
        <div className={styles.pain_points__cards}>
          {pains.map((pain, index) => (
            <div key={index} className={styles.pain_card}>
              <div className={styles.card__icon_wrapper}>{pain.icon}</div>
              <div className={styles.card__title}>{pain.title}</div>
              <div className={styles.card__description}>{pain.description}</div>
              <div className={styles.card__solution}>✓ {pain.solution}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
